import { createFileRoute } from '@tanstack/react-router';
import { BroadcastIndexRouteView } from '@/pages/workspaces/broadcasts/broadcast/routing';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/')({
  component: BroadcastIndexRouteView,
});
